// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1C0iA","itemTitle":"ClientEmergencyInfo_itemTitle__3Zv7O","itemText":"ClientEmergencyInfo_itemText__20Fg-"};